<script setup>

</script>

<template>
  <h4 class="text-dark p-2 border-alert-error border-2 text-xl flex gap-2 leading-normal items-center rounded-2xl">
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" class="text-alert-error min-w-7" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.0264 27.3337C9.2347 27.3337 4.8597 24.8337 2.46387 20.667C0.0680338 16.5524 0.0680338 11.5003 2.46387 7.33366C4.8597 3.21908 9.2347 0.666992 14.0264 0.666992C18.766 0.666992 23.141 3.21908 25.5368 7.33366C27.9326 11.5003 27.9326 16.5524 25.5368 20.667C23.141 24.8337 18.766 27.3337 14.0264 27.3337ZM14.0264 7.33366C13.2972 7.33366 12.7764 7.90658 12.7764 8.58366V14.417C12.7764 15.1462 13.2972 15.667 14.0264 15.667C14.7035 15.667 15.2764 15.1462 15.2764 14.417V8.58366C15.2764 7.90658 14.7035 7.33366 14.0264 7.33366ZM12.3597 19.0003C12.3597 19.9378 13.0889 20.667 14.0264 20.667C14.9118 20.667 15.693 19.9378 15.693 19.0003C15.693 18.1149 14.9118 17.3337 14.0264 17.3337C13.0889 17.3337 12.3597 18.1149 12.3597 19.0003Z" fill="currentColor"/>
    </svg>
    <slot />
  </h4>
</template>
